import { render, staticRenderFns } from "./distributionOrder.vue?vue&type=template&id=09b3043e&scoped=true&"
import script from "./distributionOrder.vue?vue&type=script&lang=js&"
export * from "./distributionOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b3043e",
  null
  
)

export default component.exports